// ==========================================================================
// Carousel Module
// ==========================================================================

export default class Carousel {
	constructor(carouselElement) {
		this.carousel = carouselElement;
		this.track = this.carousel.querySelector('.carousel__track');
		this.slides = this.carousel.querySelectorAll('.carousel__slide');
		this.prevBtn = this.carousel.querySelector('.carousel__btn--prev');
		this.nextBtn = this.carousel.querySelector('.carousel__btn--next');

		this.currentIndex = 0;
		this.slideWidth = 0;

		this.init();
	}

	init() {
		if (!this.track || this.slides.length === 0) return;

		this.updateSlideWidth();
		this.updatePosition();

		if (this.prevBtn) {
			this.prevBtn.addEventListener('click', () => this.prev());
		}

		if (this.nextBtn) {
			this.nextBtn.addEventListener('click', () => this.next());
		}

		window.addEventListener('resize', () => {
			this.updateSlideWidth();
			this.updatePosition();
		});
	}

	updateSlideWidth() {
		this.slideWidth = this.slides[0].offsetWidth;
	}

	next() {
		if (this.currentIndex < this.slides.length - 1) {
			this.currentIndex++;
			this.updatePosition();
		}
	}

	prev() {
		if (this.currentIndex > 0) {
			this.currentIndex--;
			this.updatePosition();
		}
	}

	updatePosition() {
		const translateX = -this.currentIndex * this.slideWidth;
		this.track.style.transform = `translateX(${translateX}px)`;
	}
}

// Initialize all carousels
document.addEventListener('DOMContentLoaded', () => {
	document.querySelectorAll('.carousel').forEach(carousel => {
		new Carousel(carousel);
	});
});
